
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorSeccion } from './controlador';
    import _ from 'lodash';
    import editar_precio from './barra-lateral-editar-precio.vue';
    import * as Publicaciones from '@lib/MercadoLibre/Publicaciones';
    import { Utiles } from '@/__env/pluggins/event-bus';
    import { Publicacion } from '@lib/MercadoLibre/Publicaciones';
    @Component( {
        name: "Componente",
        props: {},
        components: {
            editar_precio,
        }
    } )
    export default class Componente extends Vue
    {

        @Prop()
        public Controlador: ControladorSeccion;
        public get Buscador() { return this.Controlador.Buscador; }
        public get Estado() { return this.Controlador.Buscador.Estado; }

        public Abierto: boolean = true;


        public SubModo: string = '';


        Cerrar()
        {

        }
    }
